export default __webpack_public_path__ + "static/media/banner.f34c7fb1.webp";